// extracted by mini-css-extract-plugin
module.exports =  {"required":"labels-module__required___xl16b"};